import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const InfoNoIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <circle cx={12} cy={12} r={9.5} stroke="currentColor" />
            <path stroke="currentColor" d="m9 9 6 6M9 15l6-6" />
        </svg>
    </IconWrapper>
)
